import { Store } from '@ngxs/store';
import { PaymentProvider } from '@finxone-platform/shared/sys-config-types';
import { ProjectSettingsState } from '../state/project-settings.state';

/**
 * Helper to handle query params so if param is nullish then not added to request url
 * @param params
 */
export function buildQueryString(params: Record<string, any>): string {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value) && value.length > 0) {
        // Each array item becomes a separate query parameter
        value.forEach((item) => {
          if (item !== undefined && item !== null && item !== '') {
            queryParams.append(key, item.toString());
          }
        });
      } else if (!Array.isArray(value)) {
        // Handle non-array parameters
        queryParams.append(key, value.toString());
      }
    }
  });
  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : '';
}

export const getQueryParamValueByKey = (key: string): string => {
  try {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get(key) || '';
  } catch (error) {
    return '';
  }
};

export function getPageSizeByProvider(store: Store): number {
  const provider = store.selectSnapshot(ProjectSettingsState.getProjectServiceProvider);
  if (provider === PaymentProvider.SAASCADA) return 5;
  return 10;
}
